import { Workbook } from "exceljs";
import { EducationalEngagementResponse } from "../../services/reports.service";
import { applyHeaderStyle, rateFillArgb } from "./workbook-styles";

export const addEducationalEngagementSheets = (
	workbook: Workbook,
	data: EducationalEngagementResponse,
): void => {
	const byItem = workbook.addWorksheet("By content item");
	byItem.columns = [
		{ header: "Title", key: "title", width: 36 },
		{ header: "Type", key: "type", width: 14 },
		{ header: "Accesses", key: "accesses", width: 12 },
		{ header: "Access rate %", key: "accessRate", width: 14 },
	];
	applyHeaderStyle(byItem.getRow(1));

	for (const item of data.byItem) {
		const r = byItem.addRow(item);
		r.getCell("accessRate").numFmt = "0.0";
		const rate = rateFillArgb(item.accessRate);
		if (rate) {
			r.getCell("accessRate").fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: rate },
			};
		}
	}

	const byEnrollment = workbook.addWorksheet("By enrollment");
	const itemColumns = data.byItem.map((i, idx) => ({
		header: i.title || `Item ${idx + 1}`,
		key: `item_${i.itemId}`,
		width: 18,
	}));
	byEnrollment.columns = [
		{ header: "Participant", key: "participantName", width: 28 },
		...itemColumns,
	];
	applyHeaderStyle(byEnrollment.getRow(1));

	for (const enr of data.byEnrollment) {
		const rowData: Record<string, unknown> = {
			participantName: enr.participantName,
		};
		for (const flag of enr.items) {
			rowData[`item_${flag.itemId}`] = flag.accessed ? "Yes" : "No";
		}
		byEnrollment.addRow(rowData);
	}
};
